import React from "react";

const LEGEND_ITEMS = {
  original: [
    { key: "mapped", label: "Selected & Mapped", swatch: "data-table__legend__swatch--mapped" },
    { key: "selected", label: "Selected", swatch: "data-table__legend__swatch--selected" },
    { key: "unselected", label: "Unselected", swatch: "data-table__legend__swatch--unselected" },
    { key: "alerts", label: "Alerts", swatch: "data-table__legend__swatch--error" },
  ],
};

const TableLegend = ({ view, counts = {} }) => {
  const items = LEGEND_ITEMS[view];
  if (!items) return null;

  return (
    <div className="data-table__legend">
      {items.map(({ key, label, swatch }) => (
        <div key={key} className="data-table__legend__item">
          <span className={`data-table__legend__swatch ${swatch}`} />
          <span className="data-table__legend__label">
            {label}
            {counts[key] != null && ` (${counts[key]})`}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TableLegend;
